declare var jQuery: any;

export function scrollTo (widget: string, duration?: number): void {
    let widgetElement = document.querySelector(`[data-vfeo="${widget}"]`);

    if (!widgetElement) {
        widgetElement = document.querySelector(widget);
    }

    if (!duration) {
        duration = 500;
    }

    jQuery('html, body').animate({
        scrollTop: jQuery(widgetElement).offset().top - 150
    }, duration);
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/scroll-to.ts